(function () {
  'use strict';

  var CANONICAL_ORIGIN = 'https://preworn.com';
  var LEGACY_HOSTS = {
    'preworn.ltd': true,
    'www.preworn.ltd': true
  };

  function isStorefrontHost(hostname) {
    hostname = String(hostname || '').toLowerCase();
    return hostname === String(window.location.hostname || '').toLowerCase() ||
      hostname === 'preworn.com' || hostname === 'www.preworn.com' ||
      !!LEGACY_HOSTS[hostname];
  }

  function modernSearchUrl(url) {
    if (!isStorefrontHost(url.hostname) ||
        !/^\/collections\/all\/?$/.test(url.pathname)) return '';
    var search = new URLSearchParams(url.search);
    search.delete('sort_by');
    if (!String(search.get('q') || '').trim() && !search.has('sort')) {
      search.set('sort', 'newest');
    }
    return '/search?' + search.toString() + url.hash;
  }

  function redirectObsoleteAllCollection() {
    try {
      var current = new URL(window.location.href);
      var replacement = modernSearchUrl(current);
      if (!replacement) return false;
      window.location.replace(replacement);
      return true;
    } catch (error) {
      return false;
    }
  }

  function canonicaliseLink(link) {
    if (!link || typeof link.getAttribute !== 'function') return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    try {
      var url = new URL(href, window.location.href);
      var replacement = modernSearchUrl(url);
      if (replacement) {
        link.setAttribute('href', replacement);
        return;
      }
      if (LEGACY_HOSTS[String(url.hostname || '').toLowerCase()]) {
        link.setAttribute('href', CANONICAL_ORIGIN + url.pathname + url.search + url.hash);
      }
    } catch (error) {}
  }

  function canonicaliseLinks(root) {
    if (!root) return;
    if (typeof root.matches === 'function' && root.matches('a[href], area[href]')) {
      canonicaliseLink(root);
    }
    if (typeof root.querySelectorAll !== 'function') return;
    var links = root.querySelectorAll('a[href], area[href]');
    for (var index = 0; index < links.length; index++) canonicaliseLink(links[index]);
  }

  function start() {
    if (redirectObsoleteAllCollection()) return;
    canonicaliseLinks(document);
    if (typeof window.MutationObserver !== 'function' || !document.documentElement) return;
    new window.MutationObserver(function (mutations) {
      for (var index = 0; index < mutations.length; index++) {
        var mutation = mutations[index];
        if (mutation.type === 'attributes') canonicaliseLink(mutation.target);
        for (var child = 0; child < mutation.addedNodes.length; child++) {
          canonicaliseLinks(mutation.addedNodes[child]);
        }
      }
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
